module.exports = __webpack_public_path__ + "3c975e8f28576903f9c43ff12fabac19.png";